import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bspop-over',
	templateUrl:'./BSPopOverPluginCompPage.html',
	styles: [],
	styleUrls:['./BSPopOverPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSPopOverPluginCompPage
{
	mdContent_850 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.popovers.BSPopOver;
\`\`\``;
	mdContent_851 = `\`\`\`java
BSPopOver()
\`\`\``;
	mdContent_852 = `\`\`\`java
BSButton&lt;?&gt; btn = new BSButton&lt;&gt;("Help");
BSPopOver.attach(btn, "Info", "Helpful details here", BSPlacements.Right);
\`\`\``;
}
